import { DTOError } from 'src/error/errors/DTOError';

import type { CreateOrderSuccessPayload } from './types';

export const createOrderSuccessDTO = (
  data: unknown,
): CreateOrderSuccessPayload => {
  if (
    !data ||
    typeof data !== 'object' ||
    !('id' in data) ||
    typeof data.id !== 'number' ||
    !('secret_stamp' in data) ||
    !(typeof data.secret_stamp === 'string' || data.secret_stamp === null)
  ) {
    throw new DTOError('createOrderSuccessDTO', data);
  }

  return {
    id: data.id,
    pin: data.secret_stamp,
  };
};
